<!-- In explicit-anchor mode the panel stays invisible for its first frame,
     until clampToViewport() has actually measured and corrected its position —
     otherwise that first frame paints at the raw, unclamped anchor and the
     panel visibly jumps once the fix lands. Default mode has no such
     correction pass, so it's never hidden. -->
<div *ngIf="isOpen" #panel
     class="z-[500] w-72 rounded-2xl border border-gray-200 bg-white shadow-xl overflow-hidden dark:bg-gray-900 dark:border-gray-700"
     [class.absolute]="anchorTop == null"
     [class.left-0]="anchorTop == null"
     [class.top-full]="anchorTop == null"
     [class.mt-2]="anchorTop == null"
     [class.invisible]="anchorTop != null && !positioned"
     [class.pointer-events-none]="anchorTop != null && !positioned"
     [style.position]="anchorTop != null ? anchorPosition : null"
     [style.top.px]="anchorTop != null ? resolvedTop : null"
     [style.left.px]="anchorTop != null ? resolvedLeft : null"
     (click)="$event.stopPropagation()">
  <!-- Category tabs -->
  <div class="flex border-b border-gray-100 dark:border-gray-800 px-2 pt-2 gap-1">
    <button *ngFor="let cat of categories; let i = index" type="button" (click)="setTab(i)"
      class="px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors"
      [class.bg-brand-500]="activeTab === i" [class.text-white]="activeTab === i"
      [class.text-gray-500]="activeTab !== i" [class.hover:bg-gray-100]="activeTab !== i">
      {{ cat.label }}
    </button>
  </div>
  <!-- Emoji grid -->
  <div class="flex flex-wrap gap-0.5 p-3 max-h-44 overflow-y-auto">
    <button *ngFor="let emoji of categories[activeTab].emojis" type="button" (click)="onPick(emoji, $event)"
      class="text-xl w-9 h-9 flex items-center justify-center rounded-lg hover:bg-gray-100 dark:hover:bg-white/10 hover:scale-110 transition-all">
      {{ emoji }}
    </button>
  </div>
</div>
